import { render, staticRenderFns } from "./examsettings.vue?vue&type=template&id=0194a60d&"
import script from "./examsettings.vue?vue&type=script&lang=js&"
export * from "./examsettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports